module.exports = __webpack_public_path__ + "media/images/icon-success-white-29277a3efa7ec6336af0939a91f29391.svg";